import { IButtonProps, PrimaryButton as FabricPrimaryButton, Spinner } from "@fluentui/react";
import React from "react";

export type PrimarySubmitButtonProps = PrimarySubmitLoadingButtonProps | PrimarySubmitClassicButtonProps;

type PrimarySubmitButtonBaseProps = Pick<IButtonProps, "disabled"> & {
    text: string;
    testId?: string;
};

interface PrimarySubmitLoadingButtonProps extends PrimarySubmitButtonBaseProps {
    type: "loading";
    isLoading: boolean;
}

interface PrimarySubmitClassicButtonProps extends PrimarySubmitButtonBaseProps {
    type?: "classic";
}

export const PrimarySubmitButton: React.FunctionComponent<PrimarySubmitButtonProps> = (
    props: PrimarySubmitButtonProps
) => {
    if (props.type === "loading") {
        return (
            <FabricPrimaryButton
                data-testid={props.testId}
                type="submit"
                text={!props.isLoading ? props.text : undefined}
                disabled={props.disabled || props.isLoading}
                style={{ width: 90 }}
            >
                {props.isLoading && <Spinner hidden={false} />}
            </FabricPrimaryButton>
        );
    }

    return <FabricPrimaryButton {...props} type="submit" />;
};
